import React from "react";
import "@/App.css";
import { FormProvider } from "@/context/FormContext";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Promise from "@/components/sections/Promise";
import WhyNow from "@/components/sections/WhyNow";
import WhatsInBrief from "@/components/sections/WhatsInBrief";
import SampleIssue from "@/components/sections/SampleIssue";
import WhoItsFor from "@/components/sections/WhoItsFor";
import SecondCta from "@/components/sections/SecondCta";
import FaqSection from "@/components/sections/FaqSection";
import Footer from "@/components/sections/Footer";

function App() {
    return (
        <div className="App" data-testid="app-root">
            <a className="skip-link" href="#main-content">
                Skip to content
            </a>
            <FormProvider>
                <Header />
                <main id="main-content">
                    <Hero />
                    <Promise />
                    <WhyNow />
                    <WhatsInBrief />
                    <SampleIssue />
                    <WhoItsFor />
                    {/*
                        Section 6 (Social Proof) — omitted at launch per brief:
                        no fabricated testimonials or subscriber counts.
                        Reintroduce only when 1,000+ verified subscribers exist.
                    */}
                    <SecondCta />
                    <FaqSection />
                </main>
                <Footer />
            </FormProvider>
        </div>
    );
}

export default App;
